import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFeedInfoOperations, setIsChangesMade } from '../../../slices/feeds/reducer';
import { feedOperations } from '../../../common/feedTypes';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import checkPermission from '../../../Components/Hooks/PermissionHook';
import { createSelector } from 'reselect';

function AddSortingFiltersBtn() {
  const dispatch = useDispatch();

  const selectFeedInfo = createSelector(state => state.Feed, state => state.feedInfo);
  const feedInfo = useSelector(selectFeedInfo);

  function addOperationFunc(data) {
    dispatch(setFeedInfoOperations([...feedInfo.operations, data]));
    dispatch(setIsChangesMade(true));
  }

  const selectBrandPath = createSelector(state => state.MenuData, state => state.brandPath);
  const brandPath = useSelector(selectBrandPath);

  if (checkPermission("brands", brandPath, "feedEdit")) {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="button" className='btn btn-success ms-auto me-0 my-auto py-0' style={{ height: "38px" }}>
          Add Sorting or Filter
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => addOperationFunc(feedOperations[1])}>
            <i className='mdi mdi-sort-variant me-1 fs-14 align-bottom'></i>Sorting
          </DropdownItem>
          <DropdownItem onClick={() => addOperationFunc(feedOperations[2])}>
            <i className='ri-checkbox-circle-line me-1 fs-14 align-bottom'></i>Priority
          </DropdownItem>
          <DropdownItem onClick={() => addOperationFunc(feedOperations[3])}>
            <i className='ri-filter-2-line me-1 fs-14 align-bottom'></i>Filter
          </DropdownItem>
          <DropdownItem onClick={() => addOperationFunc(feedOperations[4])}>
            <i className='ri-checkbox-circle-line me-1 fs-14 align-bottom'></i>Replace text
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  } else {
    return null;
  }

}

export default AddSortingFiltersBtn
